import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';


@Component({
  selector: 'app-filter-tool',
  standalone: true,
  imports: [MatIconModule,CommonModule,FormsModule],
  templateUrl: './filter-tool.component.html',
  styleUrl: './filter-tool.component.css'
})
export class FilterToolComponent {

  constructor(
    private router : Router
  ){

  }
 
  @Input() groupByOptions: string[] = ['None'];
  @Input() statusOptions: string[] = ['Active'];
  @Output() search = new EventEmitter<string>();
  @Output() clearAll = new EventEmitter<void>();
  @Output() viewType = new EventEmitter<'list' | 'grid'>();
  currentView: 'list' | 'grid';
  onSearch(event: Event) {
    const value = (event.target as HTMLInputElement).value; // Explicitly cast to HTMLInputElement
    this.search.emit(value);
  }
  onClearAll() {
    this.clearAll.emit();
  }
  toggleView(view: 'list' | 'grid') {
      this.currentView = view;
      this.viewType.emit(view);
    }

}
